// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import DoubleRightOutlinedSvg from "@ant-design/icons-svg/es/asn/DoubleRightOutlined";
import AntdIcon from '../components/AntdIcon';

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleRightOutlinedSvg
  }));
};

DoubleRightOutlined.displayName = 'DoubleRightOutlined';
export default React.forwardRef(DoubleRightOutlined);